import UsuarioTelefoneService from "@/services/UsuarioTelefoneService";

export const usuarioTelefone = {
  namespaced: true,
  state: {
    usuarioTelefone: {},
  },
  actions: {
    getUsuarioTelefone({ commit }, payload) {
      return UsuarioTelefoneService.GetUsuarioTelefone(payload).then(
        (usuarioTelefone) => {
          return Promise.resolve(usuarioTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postUsuarioTelefone({ commit }, payload) {
      return UsuarioTelefoneService.PostUsuarioTelefone(payload).then(
        (usuarioTelefone) => {
          return Promise.resolve(usuarioTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putUsuarioTelefone({ commit }, payload) {
      return UsuarioTelefoneService.PutUsuarioTelefone(payload).then(
        (usuarioTelefone) => {
          return Promise.resolve(usuarioTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteUsuarioTelefone({ commit }, payload) {
      return UsuarioTelefoneService.DeleteUsuarioTelefone(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getUsuarioTelefoneOData({ commit }, payload) {
      return UsuarioTelefoneService.GetUsuarioTelefoneOData(payload).then(
        (usuarioTelefone) => {
          return Promise.resolve(usuarioTelefone);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default usuarioTelefone;
